import { combineReducers } from 'redux';
import productCategories from './categories';
import selectedCategories from './selected';

export default combineReducers({
  categories: productCategories,
  selected: selectedCategories,
});
